import Swiper from "swiper/bundle";

const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];
const domReady = () => {
  new shopBLOCKS;
};

class shopBLOCKS {
  constructor() {
    this.MainImg();
    this.CatList();
  }
  
  MainImg () {
    const mainSlider = new Swiper('.p-shop-article-main__slide', {
      grabCursor: true,
      speed: 400,
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    });
  }
  
  CatList() {
    const btn = document.getElementById('listToggle');
    const target = document.getElementById('listWrap');

    if (!btn || !target) return;

    btn.addEventListener('click', () => {
      btn.classList.toggle('is-open');
      
      if (btn.classList.contains('is-open')) {
        target.style.display = 'block';
        btn.textContent = '検索カテゴリーを隠す';
      } else {
        target.style.display = 'none';
        btn.textContent = '検索カテゴリーをすべて表示';
      }
    });
  }
}

export default function SHOP () {
  w.addEventListener('load', domReady);
}